import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { AsyncUtils } from '@utils/AsyncUtils';

import Quill from 'quill';


@Component({
    selector: 'text-editor-quill',
    templateUrl: './text-editor-quill.component.html',
    styleUrls: ['./text-editor-quill.component.scss'],
})
export class TextEditorQuillComponent implements OnInit, OnChanges, OnDestroy {

    @Input('source') Source: any;
    @Input('disabled') Disabled: boolean;
    @Output() callback: EventEmitter<any> = new EventEmitter();

    @Input('custom') customFeatures: boolean = false;

    @Input('limit') MaxCharacters: number = 2000;
    // bloquear o adicionar imagens base64 ao texto
    @Input('allowBase64') allowBase64: boolean = false;

    public QuillId: string;
    public QuillEditor;
    private cursorPosition;

    public SourceLength: number = 0;

    constructor() {

    }

    async ngOnInit() {

        this.QuillEditor = null;
        // await this.initQuill();


        // if (this.Disabled)
        //     this.QuillEditor.enable(false);

    }

    async ngOnChanges(changes: SimpleChanges) {

        // console.log(this.QuillId);


        if (!this.QuillEditor) await this.initQuill();
        //  return;

        // console.log(this.QuillId);
        // if (!this.QuillEditor) await this.initQuill();

        // clean html
        const source = this.Source ? ("" + this.Source?.replace(/&nbsp;/g, ' '))?.slice() : '';

        // console.log(source);


        try {
            this.QuillEditor.enable(true);

            if (source?.trim()?.startsWith('<')) {
                try {

                    // Se não houver <p>, adiciona no final do conteúdo
                    if (!source?.trim()?.startsWith('<p'))
                        this.QuillEditor.clipboard.dangerouslyPasteHTML(this.QuillEditor.getLength(), `${source}`);

                    else
                        this.QuillEditor.root.innerHTML = source?.slice();

                } catch (error) {

                    this.QuillEditor.setText(source || '');
                }
            }
            else
                this.QuillEditor.setText(source || '');


            if (source && this.QuillEditor && this.QuillEditor.root) {

                this.QuillEditor.root.dataset.placeholder = '';
                this.QuillEditor.root.setAttribute('data-placeholder', '');

            }

            this.SourceLength = this.QuillEditor.getLength();

        } catch (error) {

        }

        console.log("quill editor disabled ------->", this.Disabled);


        if (this.Disabled)
            this.QuillEditor.enable(false);

    }

    ngOnDestroy() {
        if (this.QuillEditor) {
            // 1. Remover todos os event listeners
            this.QuillEditor.off('text-change');
            this.QuillEditor.off('selection-change');

            // 2. (Opcional) Remover manualmente o conteúdo do editor
            const editorElement = this.QuillEditor.root?.parentElement;

            if (editorElement) {
                editorElement.innerHTML = ''; // remove tudo do DOM
            }

            // 3. Anular a referência
            this.QuillEditor = null;
            this.QuillId = null;
        }
    }

    private async initQuill() {

        console.log("init quill ->> ", this.QuillId);

        if (this.QuillEditor) return;

        if (!this.QuillId)
            this.QuillId = 'quill_' + (Math.random() + 1).toString(36).substring(7);


        console.log("init quill ->> ", this.QuillId);

        //DELAY DE CARREGAMENTO
        await AsyncUtils.Sleep(10);

        const txtArea = document.createElement('textarea');

        if (!document.getElementById(this.QuillId)) return;

        const icons = Quill.import('ui/icons');
        icons['showHtml'] = '<b>HTML</b>';
        // icons['showTags'] = '<b>TAGS</b>';
        // icons['tag1'] = '<b>TAG 1</b>';
        // icons['tag2'] = '<b>Tag 2</b>';

        let quillOptions = {
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    // ['image','link'],
                    ['link'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    // [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'align': [] }],
                    ['clean'],
                    // ['code-block'],
                    // ['showHtml']
                ],
                // imageResize: {
                // 	displaySize: true
                // }, 
                // syntax: true,    
            },
            placeholder: 'adicione o seu texto aqui...',
            theme: 'snow'  // or 'bubble');
        };

        if (this.customFeatures) {

            quillOptions = {
                modules: {
                    toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        // ['image','link'],
                        ['link'],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        // [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'align': [] }],
                        ['clean'],
                        // ['code-block'],
                        ['showHtml']
                    ],
                    // imageResize: {
                    // 	displaySize: true
                    // }, 
                    // syntax: true,    
                },
                placeholder: 'adicione o texto aqui...',
                theme: 'snow'  // or 'bubble');
            };
        }

        this.QuillEditor = new Quill(`#${this.QuillId}`, quillOptions);

        this.QuillEditor.on('text-change', (delta, oldDelta, source) => {

            const html = this.QuillEditor.root.innerHTML;
            let cleanhtml = this.QuillEditor.root.innerHTML;
            const isEmpty = html === '<p><br></p>';

            // Atualiza cursor
            this.cursorPosition = this.QuillEditor.getSelection();

            // Regex para apanhar base64 comum (imagens, ficheiros, etc.)
            const base64Regex = /data:[a-z]+\/[a-z0-9.+-]+;base64,[A-Za-z0-9+/=]+/gi;

            console.log("text-> ", html);

            if (!this.allowBase64 && base64Regex.test(html)) {
                // Remove base64 do editor
                cleanhtml = html.replace(base64Regex, '').replace('<img src="">', '');
                this.QuillEditor.clipboard.dangerouslyPasteHTML(cleanhtml);
            }

            // Atualiza textarea, se necessário
            if (txtArea) txtArea.value = cleanhtml;

            // console.log(delta, oldDelta, source);
            if (source == 'api') {
                // console.log("An API call triggered this change.");
            } else if (source == 'user') {
                const contentToEmit = isEmpty ? null : cleanhtml,
                    textLength = (this.QuillEditor.getLength() - 1);

                if (textLength >= this.MaxCharacters) {
                    // Remove caracteres extra
                    this.QuillEditor.deleteText(this.MaxCharacters, textLength);
                }
                else if (this.callback) {
                    this.callback.emit(contentToEmit);

                }

                this.SourceLength = (this.QuillEditor.getLength() - 1);
                // this.Source = txtArea.value;
            }
        });


        this.QuillEditor.on('selection-change', (range, oldRange, source) => {
            this.cursorPosition = this.QuillEditor.getSelection() || this.cursorPosition;

            // if (range) {
            // 	if (range.length == 0) {
            // 		console.log('User cursor is on', range.index);
            // 	} else {
            // 		// const text = this.QuillEditor.getText(range.index, range.length);
            // 		// console.log('User has highlighted', text);
            // 	}
            // } else {
            // 	console.log('Cursor not in the editor');
            // }
        });

        const htmlEditor = this.QuillEditor.addContainer('ql-custom');
        htmlEditor.style.display = 'none';

        htmlEditor.appendChild(txtArea);

        if (this.customFeatures) {

            const customButtonHTML = document.querySelector('.ql-showHtml');
            // // const customButtonTAGS: any = document.querySelector('.ql-tags');

            customButtonHTML.addEventListener('click', () => {

                if (this.Disabled) return;

                if (txtArea.style.display === '')
                    this.QuillEditor.root.innerHTML = txtArea.value;

                htmlEditor.style.display = htmlEditor.style.display === 'none' ? '' : 'none';

            });

            // customButtonTAGS.addEventListener('click', (e) => {
            // 	const v: any = document.querySelector('.ql-picker-item.ql-selected');

            // 	if (!v || !v.dataset?.value) return;

            // 	if (!customButtonTAGS.classList.value.includes('ql-expanded')) {
            // 		this.QuillEditor.insertText(this.cursorPosition?.index || 0, v.dataset?.value);
            // 		// this.QuillEditor.insertText(this.cursorPosition?.index || 0, "#" + v.dataset?.value + "#");
            // 	}
            // 	v.classList.remove('ql-selected');

            // });
        }

        return;
    }

}
